export const SIZES = {
    NONE: 'none',
    INLINE: 'inline',
    TINY: 'tiny',
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
};
